var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { SystemAttachmentModel, SystemsClient } from "@/app/api/battery-portal-api";
import { HttpHelper } from "@/app/utils/http-helper";
import { Alert } from "@/common/utils/alert";
import { Notifier } from "@/common/utils/notifier";
import { Component, Prop, Vue, Watch, Ref } from "vue-facing-decorator";
const systemClient = new SystemsClient(window.apiUrl);
let SystemAttachmentsVue = class SystemAttachmentsVue extends Vue {
    constructor() {
        super(...arguments);
        this.msg = new Alert();
        this.working = false;
        this.isDragging = false;
        this.showPreview = false;
        this.previewFile = null;
        this.hasLoaded = false;
        this.attachments = [];
        // Supported file types
        this.imageExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
        this.videoExtensions = ['.mp4', '.avi', '.mov'];
        this.documentExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.csv'];
    }
    // Expose load method to parent component
    load() {
        if (!this.hasLoaded) {
            this.hasLoaded = true;
            this.loadAttachments();
        }
    }
    reload(isTabActive) {
        this.hasLoaded = false;
        if (isTabActive) {
            this.load();
        }
    }
    loadAttachments() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.systemId)
                return;
            this.working = true;
            try {
                const response = yield systemClient.getSystemAttachments(this.systemId);
                this.attachments = (response.attachments || []).map(att => (Object.assign(Object.assign({}, att), { previewUrl: this.createPreviewUrl(att) })));
                console.log('load attachments', this.attachments);
            }
            catch (ex) {
                console.error(ex);
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.working = false;
            }
        });
    }
    triggerFileInput() {
        if (this.canEdit) {
            this.fileInput.click();
        }
    }
    handleDrop(event) {
        var _a;
        this.isDragging = false;
        if (!this.canEdit)
            return;
        const files = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files;
        if (files) {
            this.processFiles(Array.from(files));
        }
    }
    handleFileSelect(event) {
        const input = event.target;
        if (input.files) {
            this.processFiles(Array.from(input.files));
        }
        // Reset input
        input.value = '';
    }
    processFiles(files) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const file of files) {
                if (!this.isFileTypeSupported(file)) {
                    Notifier.onError(`File type not supported: ${file.name}`);
                    continue;
                }
                if (file.size > 5 * 1024 * 1024) {
                    Notifier.onError(`File too large (max 5MB): ${file.name}`);
                    continue;
                }
                try {
                    const fileDataUrl = yield this.readFileAsBase64(file);
                    // Extract base64 string without data URL prefix
                    const base64String = fileDataUrl.includes(',') ? fileDataUrl.split(',')[1] : fileDataUrl;
                    const attachment = {
                        systemAttachmentId: 0,
                        systemId: this.systemId,
                        fileName: file.name,
                        fileType: file.type || this.getMimeType(file.name),
                        fileData: base64String,
                        uploadedAt: new Date(),
                        uploadedBy: 0,
                        tempId: this.generateTempId(),
                        previewUrl: fileDataUrl,
                        fileSize: file.size
                    };
                    this.attachments.push(attachment);
                }
                catch (error) {
                    Notifier.onError(`Failed to process file: ${file.name}`);
                    console.error(error);
                }
            }
            console.log('emiting event');
            try {
                this.$emit('attachmentsChanged', this.getAttachmentsForSave());
            }
            catch (emitError) {
                console.error('Error emitting attachmentsChanged event:', emitError);
            }
        });
    }
    readFileAsBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }
    createPreviewUrl(attachment) {
        if (!attachment.fileData || attachment.fileData.length === 0) {
            return '';
        }
        // FileData is already a base64 string from the API
        return `data:${attachment.fileType};base64,${attachment.fileData}`;
    }
    deleteAttachment(attachment) {
        this.$confirmModal.show(`Are you sure you want to delete ${attachment.fileName}?`, { title: "Confirm Delete" })
            .then((confirmed) => {
            if (confirmed) {
                const index = this.attachments.indexOf(attachment);
                if (index > -1) {
                    this.attachments.splice(index, 1);
                    this.$emit('attachmentsChanged', this.getAttachmentsForSave());
                    Notifier.onOk('Attachment removed');
                }
            }
        });
    }
    previewAttachment(attachment) {
        if (this.isImage(attachment) || this.isVideo(attachment)) {
            this.previewFile = attachment;
            this.showPreview = true;
        }
        else {
            this.downloadAttachment(attachment);
        }
    }
    downloadAttachment(attachment) {
        if (!attachment.fileData || attachment.fileData.length === 0) {
            Notifier.onError('File data not available');
            return;
        }
        let base64Data;
        // Check if we have a previewUrl (for newly uploaded files with data URL)
        if (attachment.previewUrl && attachment.previewUrl.startsWith('data:')) {
            base64Data = attachment.previewUrl.split(',')[1];
        }
        else {
            // For loaded attachments, fileData is already base64 string
            base64Data = attachment.fileData;
        }
        // Convert base64 to blob
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: attachment.fileType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = attachment.fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
    getAttachmentsForSave() {
        return this.attachments.map(att => {
            if (att.systemAttachmentId > 0) {
                // Existing attachment - only send ID
                return new SystemAttachmentModel({
                    systemAttachmentId: att.systemAttachmentId,
                    systemId: att.systemId,
                    fileName: att.fileName,
                    fileType: att.fileType,
                    fileData: "", // Don't send file data for existing
                    uploadedAt: att.uploadedAt,
                    uploadedBy: att.uploadedBy
                });
            }
            else {
                // New attachment - send full data
                return new SystemAttachmentModel({
                    systemAttachmentId: 0,
                    systemId: att.systemId,
                    fileName: att.fileName,
                    fileType: att.fileType,
                    fileData: att.fileData,
                    uploadedAt: att.uploadedAt,
                    uploadedBy: att.uploadedBy
                });
            }
        });
    }
    isFileTypeSupported(file) {
        const ext = this.getFileExtension(file.name).toLowerCase();
        return [...this.imageExtensions, ...this.videoExtensions, ...this.documentExtensions]
            .some(supported => supported === ext);
    }
    isImage(attachment) {
        if (!attachment)
            return false;
        const ext = this.getFileExtension(attachment.fileName).toLowerCase();
        return this.imageExtensions.includes(ext);
    }
    isVideo(attachment) {
        if (!attachment)
            return false;
        const ext = this.getFileExtension(attachment.fileName).toLowerCase();
        return this.videoExtensions.includes(ext);
    }
    getFileExtension(fileName) {
        const parts = fileName.split('.');
        return parts.length > 1 ? `.${parts[parts.length - 1]}` : '';
    }
    getPreviewUrl(attachment) {
        if (!attachment)
            return '';
        return attachment.previewUrl || this.createPreviewUrl(attachment);
    }
    getDocumentIcon(attachment) {
        const ext = this.getFileExtension(attachment.fileName).toLowerCase();
        switch (ext) {
            case '.pdf': return 'fa fa-file-pdf-o fa-5x text-danger';
            case '.doc':
            case '.docx': return 'fa fa-file-word-o fa-5x text-primary';
            case '.xls':
            case '.xlsx': return 'fa fa-file-excel-o fa-5x text-success';
            case '.txt': return 'fa fa-file-text-o fa-5x text-muted';
            default: return 'fa fa-file-o fa-5x text-muted';
        }
    }
    formatFileSize(attachment) {
        let size = attachment.fileSize;
        // If fileSize not available, estimate from base64 string length
        if (!size && attachment.fileData && typeof attachment.fileData === 'string') {
            // Base64 encoded size is approximately 4/3 of original
            size = Math.floor((attachment.fileData.length * 3) / 4);
        }
        if (!size || size === 0)
            return '';
        const kb = size / 1024;
        if (kb < 1024) {
            return `${kb.toFixed(1)} KB`;
        }
        const mb = kb / 1024;
        return `${mb.toFixed(1)} MB`;
    }
    getMimeType(fileName) {
        const ext = this.getFileExtension(fileName).toLowerCase();
        const mimeTypes = {
            '.pdf': 'application/pdf',
            '.doc': 'application/msword',
            '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            '.xls': 'application/vnd.ms-excel',
            '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            '.txt': 'text/plain',
            '.jpg': 'image/jpeg',
            '.jpeg': 'image/jpeg',
            '.png': 'image/png',
            '.gif': 'image/gif',
            '.mp4': 'video/mp4',
            '.avi': 'video/x-msvideo',
            '.mov': 'video/quicktime'
        };
        return mimeTypes[ext] || 'application/octet-stream';
    }
    generateTempId() {
        return `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
    onSystemIdChanged() {
        this.loadAttachments();
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Number)
], SystemAttachmentsVue.prototype, "systemId", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SystemAttachmentsVue.prototype, "canEdit", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_a = typeof HTMLInputElement !== "undefined" && HTMLInputElement) === "function" ? _a : Object)
], SystemAttachmentsVue.prototype, "fileInput", void 0);
__decorate([
    Watch('systemId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemAttachmentsVue.prototype, "onSystemIdChanged", null);
SystemAttachmentsVue = __decorate([
    Component({
        name: "SystemAttachmentsVue",
        emits: ['attachmentsChanged']
    })
], SystemAttachmentsVue);
export default SystemAttachmentsVue;
